import styled from 'styled-components';
import QuickLinksButton from './QuickLinksButton';
import { isSafeLink } from '../utils/isSafeLink';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonWrapper = styled.div.withConfig({
  displayName: "QuickLinksGroup__ButtonWrapper"
})(["gap:8px;padding-top:8px;align-items:center;display:flex;flex-wrap:wrap;width:100%;"]);
const QuickLinksGroup = ({
  options,
  disabled = false,
  onQuickLinkClick
}) => {
  const renderOptions = () => {
    return options.map(option => {
      const {
        label,
        url
      } = option;
      if (!label || !url || !isSafeLink(url)) {
        return null;
      }
      const handleClick = () => {
        if (onQuickLinkClick) {
          onQuickLinkClick(option);
        }
      };
      return /*#__PURE__*/_jsx(QuickLinksButton, {
        href: url,
        disabled: disabled,
        onClick: handleClick,
        children: label
      }, `quicklink.${label}`);
    });
  };
  return /*#__PURE__*/_jsx(ButtonWrapper, {
    "data-test-id": "quick-links-group",
    children: renderOptions()
  });
};
QuickLinksGroup.displayName = 'QuickLinksGroup';
export default QuickLinksGroup;